module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dropdown', {
    staticClass: "nav selector",
    attrs: {
      "menu-align": "start",
      "hide-on-click": false
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v(_vm._s(_vm.category ? _vm.category.name : _vm.$t('actions.category.all'))), _c('i', {
    staticClass: "ppj-icon-down-dir"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "primary-dropdown",
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/",
      "tag": "div",
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.category.all')))])], 1), _vm._v(" "), _vm._l((_vm.categories), function(cat, index) {
    return _c('el-dropdown-item', {
      key: cat.id,
      attrs: {
        "divided": index === 0
      }
    }, [_c('router-link', {
      staticClass: "item",
      attrs: {
        "to": {
          name: 'category',
          params: {
            id: cat.id
          }
        },
        "tag": "div"
      }
    }, [_vm._v(_vm._s(cat.name))])], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cdf693f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/category/selector.vue
// module id = 932
// module chunks = 3